export const messages = {
  addContactPage: {
    title: {
      id: 'contact.Add.Title',
      defaultMessage: 'Add Contact',
    },
  },
  editContactPage: {
    title: {
      id: 'contact.Edit.Title',
      defaultMessage: 'Edit Contact',
    },
  },
  button: {
    saveContact: {
      id: 'contact.Button.Save',
      defaultMessage: 'Save Contact',
    },
    cancel: {
      id: 'contact.Button.Cancel',
      defaultMessage: 'Cancel',
    },
  },
  checkbox: {
    invite: {
      id: 'contact.Edit.Checkbox.Invite',
      defaultMessage: 'Invite to patient portal and give access to my health information.',
    },
  },
};
